@if(!isHealthy) {
	<div class="alert alert-warning push-status-message-container" role="alert">
		<span role="alert" class="warning">
			<span class="glyphicons circle_exclamation_mark"></span>
			{{ 'ConnectionError_Warning' | translate }}
		</span>
	</div>
}
